import React, { useState } from "react";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import { ModalThemMoiNhanVay } from "./ModalThemMoiNhanVay";
import { BtnXuatDanhSach } from "../ChucNang/XuatDanhSach/BtnXuatDanhSach";
import { BtnInHopDong } from "../ChucNang/InHopDong/BtnInHopDong";

export const BtnThemMoiMobile = ({
  quyenThemMoi,
  quyenInHopDong,
  quyenXuatExcel,
  choVay,
  setChoVay,
}) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <div className="row hide-table-main show-mobile-main hidden-des-main">
      <div className="col-md-9">
        {quyenThemMoi && (
          <button
            type="button"
            className="btn btn-border-new"
            onClick={handleShow}
          >
            <i className="mdi mdi-plus"></i> Thêm mới
          </button>
        )}
      </div>

      <div className="col-md-3 d-flex just-end">
        {(quyenInHopDong || quyenXuatExcel) && (
          <div className="btn-group btn-light-new1">
            <ul>
              {quyenInHopDong && (
                <li>
                  <BtnInHopDong choVay={choVay} setChoVay={setChoVay} />
                </li>
              )}
              {quyenXuatExcel && (
                <li>
                  <BtnXuatDanhSach />
                </li>
              )}
            </ul>
          </div>
        )}
      </div>
      {show && (
        <ModalThemMoiNhanVay show={show} onHide={handleClose} NhanVayID={0} />
      )}
    </div>
  );
};
